import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";
import SectionSlider from "../Reusable/SectionSlider/SectionSlider";
import { sectionsStrategyCreation, sectionsStrategyCreationPaths } from "../../constants/sectionData";
import GlobalPoliciesFileViewPopup from "../Reusable/Popup/GlobalPoliciesFileViewPopup";
import FileSection from "../Reusable/RiskSecurity/FileSelection";
import GPAdminFileViewPopup from "../Reusable/Popup/GPAdminFileViewPopup";
import StrategyFileSelection from "../Reusable/RiskSecurity/StrategyFileSelection";
import RiskManagementToolUpload from "../GlobalPolicies/RiskManagementToolUpload";
import InflowdemanProcessUpload from "../GlobalPolicies/InflowdemanProcessUpload";
import StrategyFileSelection2 from "../Reusable/RiskSecurity/StrategyFileSelection2";

interface InflowdemanProcessSectionProps {
  isManager?: boolean;
  isAdmin?: boolean;
}

const InflowdemanProcessSection: React.FC<InflowdemanProcessSectionProps> = ({ isManager, isAdmin }) => {
  const management = localStorage.getItem("management") || "Default Location Name";
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState<any>(null);
  const [selectedSectionName, setSelectedSectionName] = useState<string>("");

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const handleFileUploadSuccess = () => {
    // Handle any logic after successful file upload
    console.log("File uploaded successfully");
  };

  // const handleViewClick = (fileData: any, sectionName: string) => {
  //   setSelectedFileData(fileData); // Set the file data for the popup
  //   setSelectedSectionName(sectionName); // Set the section name for the popup
  //   setPopupOpen(true); // Open the popup
  // };
  const handleViewClick = ({ fileData, sectionName, refresh }: { 
    fileData: any, 
    sectionName: string,
    refresh: () => void 
  }) => {
    setSelectedFileData({ ...fileData, refresh }); // Store refresh with file data
    setSelectedSectionName(sectionName);
    setPopupOpen(true);
  };

  const breadcrumbs = [
    <Link key="1" to="/">
      Home
    </Link>,
    <Link key="2" to="/operations/strategy-value-creation">
      Evidence Upload
    </Link>,
   <Link key="3" to="/operations/strategy-value-creation/">
         Value Creation through resources allocation
       </Link>,
    <Typography key="4">{management}</Typography>,
  ];

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sectionsStrategyCreation}
        sectionPaths={sectionsStrategyCreationPaths}
        highlightSection={"Inflow and New demand Process"}
        highlightColor="#D7A833"
        defaultColor="#666"
      />

      {/* <Typography variant="h6" sx={{ fontWeight: '600', paddingLeft: '40px', fontSize: '16px' }}>Risks and Security</Typography> */}

      <Box className="titlecardrisk" sx={{ display: "flex", gap: "10px", padding: "24px", paddingLeft: "40px", }}>
        <StrategyFileSelection
          key="section1"
          sectionName="Inflow & New demand Methodology"
          fileTitle="Provide documentation of the methodology used for managing inflow and new demand in the center, including flowcharts, process descriptions, demonstrate adherence to the methodology."
          tabName="Inflow and New demand Process"
          management={management}
          apiPath="/strategy/filter_strategy_n_value_creation"
          apiPathUpload="/strategy/strategy_n_value_creation"
          isManager={isManager}
          onFileUploadSuccess={handleFileUploadSuccess}
          // onViewClick={handleViewClick} 
          onViewClick={({ fileData, sectionName, refresh }) => {
            setSelectedFileData({ ...fileData, refresh });
            setSelectedSectionName(sectionName);
            setPopupOpen(true);
          }}
         
        />

        <StrategyFileSelection2
          key="section2"
          sectionName="Rate Card"
          fileTitle="Evidence should include the rate card document and related cost breakdowns. Rate card explaining fully loaded cost per new FTE is developed, applied and updated yearly in the center (by band, by package, by P&Q)"
          tabName="Inflow and New demand Process"
          management={management}
          apiPath="/strategy/filter_strategy_n_value_creation"
          apiPathUpload="/strategy/strategy_n_value_creation"
          isManager={isManager}
          onFileUploadSuccess={handleFileUploadSuccess}
          onViewClick={handleViewClick} // Pass file data and section name to the popup
        />
      </Box>


      {isManager && (
        <InflowdemanProcessUpload isManager={true} />

      )}

      {isAdmin && (
        <InflowdemanProcessUpload isAdmin={true} />
      )}


      {/* File View Popup */}
      {isPopupOpen && isManager && selectedFileData && (
        <GlobalPoliciesFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.created_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          userDetail={true}
          apiPath={`/strategy/strategy_n_value_creation/${selectedFileData.id}`}
        />
      )}

      {isPopupOpen && isAdmin && selectedFileData && (
        <GPAdminFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          status={selectedFileData.status}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.created_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          apiPath={`/strategy/strategy_n_value_creation/${selectedFileData.id}`} // Pass the API path for file details
          statusApiPath="/strategy/strategy_n_value_creation_status" // Pass the API path for status updates
          reason_to_approve={selectedFileData.reason_to_approve}
          reason_to_revert={selectedFileData.reason_to_revert}
          onSuccess={selectedFileData.refresh}
        />
      )}
    </>
  );
};

export default InflowdemanProcessSection;